<header class="header-bar">
  <button
    class="header-bar__menu-btn"
    (click)="menuIconChange.emit()"
    aria-label="Toggle navigation"
  >
    <mat-icon>menu</mat-icon>
  </button>

  <div class="header-bar__search">
    <xemex-search-input
      [placeholder]="searchPlaceholder()"
      [value]="searchValue()"
      (valueChange)="searchChange.emit($event)"
    />
  </div>

  <div class="header-bar__right">
    @if (docsUrl()) {
      <a
        class="header-bar__docs-btn"
        [href]="docsUrl()"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Documentation"
      >
        <mat-icon fontSet="material-icons-outlined">menu_book</mat-icon>
      </a>
    }
    @if (docsUrl()) {
      <div class="header-bar__divider"></div>
    }
    <xemex-user-menu
      [userName]="userName()"
      [userAvatar]="userAvatar()"
      [isLoading]="isLoading()"
      [partners]="partners()"
      (logout)="logout.emit()"
      (partnerSelect)="partnerSelect.emit($event)"
      (profileClick)="profileClick.emit()"
      (aboutClick)="aboutClick.emit()"
    />
  </div>
</header>
